import { render, staticRenderFns } from "./RepairCost.vue?vue&type=template&id=2bf9bfbd&scoped=true"
import script from "./RepairCost.vue?vue&type=script&lang=js"
export * from "./RepairCost.vue?vue&type=script&lang=js"
import style0 from "./RepairCost.vue?vue&type=style&index=0&id=2bf9bfbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf9bfbd",
  null
  
)

export default component.exports